"use client"
import styled from 'styled-components';
import { MockBrowser, BrowserContent } from './primitives'

const SENTIMENT_BARS = [
  { label: 'Bullish', pct: 68, color: '#16a34a' },
  { label: 'Neutral', pct: 23, color: '#bbb' },
  { label: 'Bearish', pct: 9,  color: '#dc2626' },
];

const SUPPLY_NODES = [
  { name: 'TSMC',     role: 'Fabrication', color: '#16a34a' },
  { name: 'SK Hynix', role: 'Memory',      color: '#16a34a' },
  { name: 'ASML',     role: 'Lithography', color: '#f59e0b' },
];

const PATENT_ITEMS = [
  { category: 'AI & ML', count: 45 },
  { category: 'Data Center', count: 32 },
  { category: 'Autonomous Driving', count: 28 },
];

// Data for new third row cards
const INSIDER_TRADES = [
  { name: 'J. Huang', role: 'CEO', date: 'Jun 15', value: '-$42M', color: '#dc2626' },
  { name: 'C. Stevens', role: 'CFO', date: 'Jun 10', value: '-$8.2M', color: '#dc2626' },
  { name: 'M. Kress', role: 'Director', date: 'May 20', value: '-$1.1M', color: '#dc2626' },
];

const CtxHeader = styled.div`
  margin-bottom: 12px;
`;
const CtxTitle = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #111;
`;
const CtxSub = styled.div`
  font-size: 10px;
  color: #aaa;
  margin-top: 2px;
`;
const CtxGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
`;
const CtxCard = styled.div`
  background: #f8f8f8;
  border-radius: 10px;
  padding: 12px;

  @media (max-width: 968px) {
    padding: 10px;
  }
`;
const CtxCardLabel = styled.div`
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.07em;
  color: #bbb;
  text-transform: uppercase;
  margin-bottom: 8px;
`;
const EsgWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;
const EsgSvg = styled.svg`
  width: 60px;
  height: 60px;
  flex-shrink: 0;

  @media (max-width: 400px) {
    width: 48px;
    height: 48px;
  }
`;
const EsgBadge = styled.div`
  font-size: 24px;
  font-weight: 800;
  color: #16a34a;
  letter-spacing: -0.02em;
`;
const SentScore = styled.div`
  font-size: 22px;
  font-weight: 800;
  color: #111;
  line-height: 1;
  margin-bottom: 8px;
`;
const SentUnit = styled.span`
  font-size: 12px;
  font-weight: 400;
  color: #aaa;
  margin-left: 2px;
`;
const SentBars = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;
const SentRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;
const SentLabel = styled.div`
  font-size: 9px;
  color: #888;
  width: 38px;
  flex-shrink: 0;
`;
const SentTrack = styled.div`
  flex: 1;
  height: 4px;
  background: #e4e4e4;
  border-radius: 2px;
  overflow: hidden;
`;
const SentFill = styled.div`
  height: 100%;
  width: ${({ $w }) => $w}%;
  background: ${({ $color }) => $color};
  border-radius: 2px;
`;
const SentPct = styled.div`
  font-size: 9px;
  color: #888;
  width: 24px;
  text-align: right;
  flex-shrink: 0;
`;
const WebSvg = styled.svg`
  width: 100%;
  height: 44px;
  display: block;
  margin-bottom: 6px;
`;
const WebMeta = styled.div`
  display: flex;
  align-items: baseline;
  gap: 5px;
`;
const WebVal = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: #2563eb;
`;
const WebSub = styled.div`
  font-size: 9px;
  color: #aaa;
`;
const SupplyList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 9px;
`;
const SupplyItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
const SupplyDot = styled.div`
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: ${({ color }) => color};
  flex-shrink: 0;
`;
const SupplyName = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: #111;
  line-height: 1.2;
`;
const SupplyRole = styled.div`
  font-size: 9px;
  color: #aaa;
`;
const PatentList = styled(SupplyList)``;
const PatentItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;
const PatentCategory = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: #111;
`;
const PatentCount = styled.div`
  font-size: 12px;
  font-weight: 700;
  color: #2563eb;
`;
const EmployeeWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;
const StarIcon = styled.span`
  font-size: 28px;
  color: #f59e0b;
  line-height: 1;
`;
const RatingValue = styled.div`
  font-size: 28px;
  font-weight: 800;
  color: #111;
  line-height: 1;
`;
const RatingSub = styled.div`
  font-size: 10px;
  color: #aaa;
  margin-top: 4px;
`;

// New styled components for insider trading & short interest cards
const InsiderList = styled(SupplyList)``;
const InsiderItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;
const InsiderLeft = styled.div`
  display: flex;
  flex-direction: column;
`;
const InsiderName = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: #111;
  line-height: 1.2;
`;
const InsiderRole = styled.div`
  font-size: 9px;
  color: #aaa;
`;
const InsiderDate = styled.div`
  font-size: 9px;
  color: #888;
  margin-top: 2px;
`;
const InsiderValue = styled.div`
  font-size: 12px;
  font-weight: 700;
  color: ${({ $color }) => $color || '#111'};
`;
const ShortWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;
const ShortPercentage = styled.div`
  font-size: 28px;
  font-weight: 800;
  color: #dc2626;
`;
const ShortSub = styled.div`
  font-size: 10px;
  color: #aaa;
`;

export const ContextVisual = () => (
  <MockBrowser $path={'/product_images/5.webp'}>
    <BrowserContent>
      <CtxHeader>
        <CtxTitle>NVIDIA Corp · Alt Data</CtxTitle>
        <CtxSub>Beyond price &amp; fundamentals</CtxSub>
      </CtxHeader>
      <CtxGrid>

        <CtxCard>
          <CtxCardLabel>ESG Score</CtxCardLabel>
          <EsgWrap>
            <EsgSvg viewBox="0 0 72 72" xmlns="http://www.w3.org/2000/svg">
              <circle cx="36" cy="36" r="26" fill="none" stroke="#f0f0f0" strokeWidth="5" />
              <circle
                cx="36" cy="36" r="26"
                fill="none"
                stroke="#16a34a"
                strokeWidth="5"
                strokeLinecap="round"
                strokeDasharray="117.6 163.4"
                transform="rotate(-90 36 36)"
              />
              <text x="36" y="33" textAnchor="middle" fontSize="15" fontWeight="700" fill="#111" fontFamily="system-ui,sans-serif">72</text>
              <text x="36" y="45" textAnchor="middle" fontSize="9"  fill="#888" fontFamily="system-ui,sans-serif">/ 100</text>
            </EsgSvg>
            <EsgBadge>B+</EsgBadge>
          </EsgWrap>
        </CtxCard>

        <CtxCard>
          <CtxCardLabel>News Sentiment</CtxCardLabel>
          <SentScore>81<SentUnit>/100</SentUnit></SentScore>
          <SentBars>
            {SENTIMENT_BARS.map((s) => (
              <SentRow key={s.label}>
                <SentLabel>{s.label}</SentLabel>
                <SentTrack><SentFill $w={s.pct} $color={s.color} /></SentTrack>
                <SentPct>{s.pct}%</SentPct>
              </SentRow>
            ))}
          </SentBars>
        </CtxCard>

        <CtxCard>
          <CtxCardLabel>Web Traffic Index</CtxCardLabel>
          <WebSvg viewBox="0 0 120 46" fill="none" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <linearGradient id="webgrad" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%"   stopColor="#2563eb" stopOpacity="0.2" />
                <stop offset="100%" stopColor="#2563eb" stopOpacity="0"   />
              </linearGradient>
            </defs>
            <path d="M0,40 L12,36 L24,30 L36,32 L48,20 L60,22 L72,14 L84,10 L96,12 L108,4 L120,6 L120,46 L0,46 Z" fill="url(#webgrad)" />
            <path d="M0,40 L12,36 L24,30 L36,32 L48,20 L60,22 L72,14 L84,10 L96,12 L108,4 L120,6" stroke="#2563eb" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </WebSvg>
          <WebMeta>
            <WebVal>+34%</WebVal>
            <WebSub>vs. 90-day avg</WebSub>
          </WebMeta>
        </CtxCard>

        <CtxCard>
          <CtxCardLabel>Supply Chain</CtxCardLabel>
          <SupplyList>
            {SUPPLY_NODES.map((n) => (
              <SupplyItem key={n.name}>
                <SupplyDot color={n.color} />
                <div>
                  <SupplyName>{n.name}</SupplyName>
                  <SupplyRole>{n.role}</SupplyRole>
                </div>
              </SupplyItem>
            ))}
          </SupplyList>
        </CtxCard>


        {/* third row - new */}
        <CtxCard>
          <CtxCardLabel>Recent Insider Trading</CtxCardLabel>
          <InsiderList>
            {INSIDER_TRADES.map((trade) => (
              <InsiderItem key={trade.name}>
                <InsiderLeft>
                  <InsiderName>{trade.name}</InsiderName>
                  <InsiderRole>{trade.role}</InsiderRole>
                  <InsiderDate>{trade.date}</InsiderDate>
                </InsiderLeft>
                <InsiderValue $color={trade.color}>{trade.value}</InsiderValue>
              </InsiderItem>
            ))}
          </InsiderList>
        </CtxCard>

        <CtxCard>
          <CtxCardLabel>Short Interest</CtxCardLabel>
          <ShortWrap>
            <ShortPercentage>1.2%</ShortPercentage>
            <div>
              <ShortSub>of float</ShortSub>
              <ShortSub style={{ marginTop: 2 }}>Down 0.3pp MoM</ShortSub>
            </div>
          </ShortWrap>
        </CtxCard>

      </CtxGrid>
    </BrowserContent>
  </MockBrowser>
);
